import React from "react";

const Alert = () => {
  return <div>This is alert</div>;
};

export default Alert;
